import React from 'react'
import ProductOfferStore from '../store/ProductOffer'

const ProductOfferStoreContext = React.createContext(ProductOfferStore)
const useProductOffer  = () => React.useContext(ProductOfferStoreContext)

export default useProductOffer;
